
  // Export
  module.exports =
  {

    // Edit scripts
    edit:
    {

      // Method-wide scripts
      _init: function ()
      {
     
      }

    },

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#news'), APPLICATION._PATH_PREFIX + 'news/news', 'News', 'news')        
      }

    },

    // News scripts
    news:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#news', 'News', 'news')
      }

    }

  }